/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { AddressElement } from "@stripe/react-stripe-js";
import configuration from "@/config/configuration";

const AddressForm = () => {
  return (
    <form>
      <AddressElement
        options={{
          mode: "billing",
          autocomplete: {
            mode: "google_maps_api",
            apiKey: configuration.google_maps_api_key,
          },
          fields: {
            phone: "always",
          },
          validation: {
            phone: {
              required: "always",
            },
          },
          display: {
            name: "split",
          },
        }}
      />
    </form>
  );
};

const stripe = loadStripe(configuration.stripe.publishable_key);

const StripeAddress = () => {
  return (
    <Elements
      stripe={stripe}
      options={{
        // Required for Stripe Elements without a clientSecret
        mode: "setup",
        currency: "usd",
        appearance: {
          theme: "flat",
        },
      }}
    >
      <AddressForm />
    </Elements>
  );
};

export default StripeAddress;
